import { concat, values } from 'ramda';

import { DocumentType } from '../../../../types/document';
import { FILTER } from '../../../../types/filters';
import { deprecatedPageEntity } from './internal';

/**
 * @typedef  {Object} PrismicSearchPage
 */

/**
 * @typedef {DocumentSchema} SearchPageSchema
 */

/**
 * Normalizr schema representing a search page
 */
export const SearchPageEntity = deprecatedPageEntity(DocumentType.SEARCH_PAGE, {
  processStrategy: () => ({
    uid: DocumentType.SEARCH_PAGE,
    type: DocumentType.SEARCH_PAGE,
    canonicalParameters: concat(
      values(FILTER).map((filter) => `filter_${filter}`),
      ['filter_query', 'page']
    ),
  }),
});
